import $ from 'jquery';

export const verticalTabs = () => {
  document.querySelector('.vertical-tabs')
    ? window.addEventListener('DOMContentLoaded', () => {
        const vertTabs = document.querySelector('.vertical-tabs');
        const tabs = vertTabs.querySelectorAll('[role="tab"]');
        const tabList = vertTabs.querySelector('[role="tablist"]');
        const panels = vertTabs.querySelectorAll('.vertical-tabs__content');
        let tabFocus = 0;

        if (vertTabs.classList.contains('vertical-tabs-2')) {
          //Switch between tab labels on desktop and select dropdown on mobile

          responsiveList(tabs, tabList);

          //listen for resize to switch between layouts
          var resizeTimer;
          $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              responsiveList(tabs, tabList);
            }, 500);
          });

          function responsiveList(tabs, tabList) {
            //Handling non-mobile screen sizes
            if ($(window).width() > 768) {
              //Check to see if select is on screen indicating a switch from mobile
              let $findDrop = $('.vertical-tabs__select-div');

              if ($findDrop) {
                $findDrop.replaceWith(tabList);
              }
            } else {
              //create select dropdown from tab labels and replace tab labels
              const $selectWrapper = $(
                '<div class="vertical-tabs__select-div" />'
              );

              const $select = $('<select class="vertical-tabs__tab-list" /> ');

              $.each(tabs, function () {
                const $tab = $(this);
                const $tabName = $tab.text().trim();
                let $option = $(`<option class='${$tab[0].className}' />`);

                $option.attr('value', $tab.attr('id')).html($tabName);

                $option
                  .attr('id', $tab.attr('id'))
                  .attr('aria-selected', $tab.attr('aria-selected'))
                  .attr('aria-controls', $tab.attr('aria-controls'))
                  .attr('role', $tab.attr('role'))
                  .attr('tabindex', $tab.attr('tabindex'));

                $select.append($option);
              });

              $selectWrapper.append($select);

              tabList.replaceWith($selectWrapper[0]);

              //Dropdown change handler
              $select.on('change', function (e) {
                let $target = e.target.value;
                const $tabsection = $('.vertical-tabs-2');
                const $panels = $('.vertical-tabs__content');
                const $currOption = $tabsection.find(`option[id='${$target}']`);
                const $currPanel = $tabsection.find(
                  `div[aria-labelledby='${$target}']`
                );

                $currOption
                  .attr('tabindex', 0)
                  .addClass('active')
                  .attr('aria-selected', 'true')
                  .attr('tabindex', 0);

                $select
                  .find('option')
                  .not($currOption)
                  .removeClass('active')
                  .attr('aria-selected', 'false')
                  .attr('tabindex', -1);

                $currPanel.prop({ hidden: false }).attr('tabindex', 0);

                $panels
                  .not($currPanel)
                  .prop({ hidden: true })
                  .attr('tabindex', -1);
              });
            }
          }
        }

        if (!vertTabs.classList.contains('vertical-tabs-2')) {
          if (window.innerWidth <= 768) {
            //start with none active per design, move from desktop tab layout to tablet/mobile accordion
            tabs[0].classList.remove('active');
            tabs.forEach((tab, i) => {
              tab.append(panels[i]);
            });

            vertTabs
              .querySelectorAll('[role="tabpanel"]')
              .forEach((p) => p.setAttribute('hidden', true));
          }

          window.addEventListener('resize', (e) => {
            if (window.innerWidth <= 768) {
              tabs.forEach((tab, i) => {
                tab.append(panels[i]);
              });
            }

            if (window.innerWidth > 768) {
              let panelArray = [];
              tabs.forEach((tab, i) => {
                const panel = tab.querySelector('.vertical-tabs__content');

                if (panel) {
                  panelArray.push(panel);
                  panel.remove();
                }

                panelArray.forEach((panel) => {
                  vertTabs.querySelector('.vertical-tabs__tabs').append(panel);
                });
              });
            }
          });
        }

        function changeTabs(e) {
          const target = e.target;
          let lastActiveTab = tabList.querySelector('.active');
          //maintain index between clicks and key inputs
          tabFocus = target.getAttribute('index') - 1;
          // Remove all current selected tabs
          tabList
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute('aria-selected', false));

          //Remove active from initial tab desktop
          if (lastActiveTab) {
            lastActiveTab.setAttribute('tabindex', -1);
            lastActiveTab.classList.toggle('active');
          }

          // Set this tab as selected
          target.setAttribute('aria-selected', true);
          target.setAttribute('tabindex', 0);
          target.classList.toggle('active');

          // Hide all tab panels
          vertTabs
            .querySelectorAll('[role="tabpanel"]')
            .forEach((p) => p.setAttribute('hidden', true));

          // Show the selected panel
          vertTabs
            .querySelector(`#${target.getAttribute('aria-controls')}`)
            .toggleAttribute('hidden');

            vertTabs
            .querySelector('video').currentTime = 0;

        }

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
          tab.addEventListener('click', changeTabs);
        });

        // Enable arrow navigation between tabs in the tab list

        tabList.addEventListener('keydown', (e) => {
          // Move right
          if (e.code === 'ArrowRight' || e.code === 'ArrowLeft') {
            tabs[tabFocus].setAttribute('tabindex', -1);
            tabs[tabFocus].classList.toggle('active');
            vertTabs
              .querySelector(`#panel-${tabFocus + 1}`)
              .setAttribute('hidden', '');
            if (e.code === 'ArrowRight') {
              tabFocus++;
              // If we're at the end, go to the start
              if (tabFocus >= tabs.length) {
                tabFocus = 0;
              }
              // Move left
            } else if (e.code === 'ArrowLeft') {
              tabFocus--;
              // If we're at the start, move to the end
              if (tabFocus < 0) {
                tabFocus = tabs.length - 1;
              }
            }

            tabs[tabFocus];

            tabs[tabFocus].classList.toggle('active');
            tabs[tabFocus].setAttribute('tabindex', 0);

            vertTabs
              .querySelector(`#panel-${tabFocus + 1}`)
              .removeAttribute('hidden');
            tabs[tabFocus].focus();
          }
        });
      })
    : '';
};
